exports.install = function (Vue, options) {
	//获取终端列表
	Vue.prototype.getterminal = function(value={})
	{
		if(value.qaedas_id==null)
		{
			value.qaedas_id=this.getCookie(this.config.jdid);
		}
		return this.axiosget("/api/terminal/getList",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.$store.commit('terminal',response.data.data.list);
			}
			return response;
		})
	};
	//添加终端
	Vue.prototype.addterminal = function(value)
	{
		return this.axiospost("/api/terminal/add",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.getterminal();
			}
			return response;
		});
	};
	//修改终端
	Vue.prototype.editterminal = function(value)
	{
		return this.axiospost("/api/terminal/update",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.getterminal();
			}
			return response;
		});
	};
	//删除终端
	Vue.prototype.delterminal = function(value)
	{
		return this.axiospost("/api/terminal/delete",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.getterminal();
			}
			return response;
		});
	};
}